import styled from 'styled-components';
import { containerGlobal } from 'styles/globals';

export const ContainerGlobal = styled.div`
  box-sizing: border-box;
  max-width: ${containerGlobal(1424)};
  width: 100%;
  margin-inline: auto;
`;
